<template>
    <div class="search-container">
        <div class="input-container">
            <div class="control has-icons-left">
                <input class="input is-large" type="text" :placeholder="$t('web.travel-sims.search-placeholder')" v-model="searchString" @keydown="log" v-on:keyup.enter="search">
                <span class="icon is-small is-left"><i class="far fa-globe-asia"></i></span>
            </div>
            <a class="search-button button is-large white bold" @click.prevent="search"><i class="fas fa-search"></i></a>
            <div class="country-select-container">
                <ul>
                    <li v-for="country in filteredCountries">
                        <a class="hyper6" :href="generateCountryUrl(country.country)">
                            <i class="fas fa-map-marker-alt"></i> {{ $t('country.' + country.country.slug) }}
                        </a>
                    </li>
                    <li class="no-this-place-container" v-if="showNoPlace">
                        <p class="hyper6">{{ $t('web.travel-sims.country-search-no-place-found') }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    const throttle = require('lodash/throttle');

    export default {
        props: {
            countries: Array,
        },

        data(){
            return {
                searchString: "",
                countriesWithTranslation: []
            }
        },

        computed: {
            filteredCountries(){
                return this.countriesWithTranslation.filter(country => {
                    if(this.searchString == "") return false;
                    return country.slug.includes(this.searchString.replace(/\s/g, '').toLowerCase());
                });
            },

            showNoPlace(){
                return this.searchString != "" && this.filteredCountries && this.filteredCountries.length == 0
            }
        },

        methods: {
            generateCountryUrl(country){
                return window.location.protocol + "//" + window.location.host + "/country/" + country.slug
            },

            redirectToCountry(country){
                window.location.href = this.generateCountryUrl(country);
                console.log(this.generateCountryUrl(country));
            },

            search(){
                if(this.showNoPlace) return;
                else return this.redirectToCountry(this.filteredCountries[0].country);
            },

            log: throttle(async (e) => {
                if(e.target.value && e.target.value != "") {
                    await axios.post(window.location.href, {
                        s: e.target.value
                    });
                }
            }, 1000)
        },

        mounted() {
            for(let country of this.countries){
                this.countriesWithTranslation.push({
                    country: country,
                    slug: (this.$t('country.' + country.slug, "en-US") + this.$t('country.' + country.slug, "zh-HK")).replace(/\s/g, '').toLowerCase()
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .search-container{
        .input:focus{
            border-color: #dbdbdb;
            box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.1);
        }

        .input-container{
            display: flex;
            justify-content: center;
            max-width: 500px;
            margin: auto;
            position: relative;

            .control{
                width: 100%;

                .input{
                    border-radius: 5px 0px 0px 5px;
                }
            }

            .search-button{
                background: #0176EE;
                border-radius: 0px 5px 5px 0px;
                padding: 0.5rem 2.5rem;
                border-color: transparent;

                &:hover{
                    color: #FFF;
                }
            }

            .country-select-container{
                position: absolute;
                left: 0;
                top: 100%;
                width: 100%;
                max-height: 300px;
                overflow: auto;
                z-index: 1;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                border-radius: 5px;
                margin-top: 4px;

                ul{
                    li{
                        &:before {
                            display: none;
                        }
                        padding-left: 0;

                        a {
                            padding: 12px 16px;
                            text-align: left;
                            background-color: #FFF;
                            transition: all 0.25s;
                            color: #707070;
                            display: block;

                            i{
                                margin-right: 6px;
                            }

                            &:not(:last-child) {
                                border-bottom: 1px solid #DEDEDE;
                            }

                            &:hover {
                                color: #FFF;
                                background-color: #0176EE;
                            }
                        }

                        &.no-this-place-container{
                            padding: 40px 0;
                            background: #FFF;
                        }
                    }
                }
            }
        }
    }
</style>
